import { LimiterWithUniqueLimits } from "@/services/license/license-limiters/base-limiters/limiter-with-unique-limits";

export abstract class ServiceUsingTextLimiter extends LimiterWithUniqueLimits {}
